import { faqs } from '@/mocks/dramas';
import { useState } from 'react';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-[#faf6ef] py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <p className="mb-2 text-xs font-bold uppercase tracking-widest text-[#e85d3f]">常见问题 FAQ</p>
            <h2 className="font-serif-sc text-2xl font-black text-[#26201a] md:text-3xl">关于追更站，你可能想知道的</h2>
            <p className="mt-4 text-sm leading-7 text-[#6f655a]">
              我们梳理了追更用户最常问的问题，从更新节奏、订阅提醒到剧透提示与榜单口径，一次说清楚。如果没有找到答案，欢迎来信告诉我们。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-[#26201a] px-6 py-3 text-sm font-semibold text-white hover:bg-[#e85d3f]"
            >
              还有问题？联系我们 <i className="ri-mail-send-line"></i>
            </a>
          </div>

          <div className="space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={f.q} className="overflow-hidden rounded-2xl border border-[#26201a]/8 bg-white">
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className={`font-serif-sc text-sm font-bold ${open ? 'text-[#e85d3f]' : 'text-[#26201a]'}`}>
                      {f.q}
                    </h3>
                    <i className={`text-[#a3988a] transition-transform ${open ? 'rotate-180 text-[#e85d3f]' : ''} ri-arrow-down-s-line`}></i>
                  </button>
                  {open && <p className="border-t border-[#26201a]/8 px-5 py-4 text-sm leading-7 text-[#6f655a]">{f.a}</p>}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* FAQPage 结构化数据 */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((f) => ({
              '@type': 'Question',
              name: f.q,
              acceptedAnswer: { '@type': 'Answer', text: f.a },
            })),
          }),
        }}
      />
    </section>
  );
}